import { Routes, Route } from "react-router-dom";
import AdminOwnerProfileHub from "./AdminOwnerProfileHub";
import AdminOwnerProfileSettings from "./AdminOwnerProfileSettings";

export default function AdminOwnerProfile() {
  return (
    <Routes>
      <Route index element={<AdminOwnerProfileHub />} />
      <Route path="settings" element={<AdminOwnerProfileSettings />} />
    </Routes>
  );
}
